/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconZzz = createReactComponent("outline", "zzz", "IconZzz", [["path", { "d": "M4 12h6l-6 8h6", "key": "svg-0" }], ["path", { "d": "M14 4h6l-6 8h6", "key": "svg-1" }]]);

export { IconZzz as default };
//# sourceMappingURL=IconZzz.mjs.map
